import React from 'react';
import PropTypes from 'prop-types';
import enhance from './enhance';
import styles from './styles.module.scss';
import Subsection from './Subsection';

export const SeriesPanel = ({
  subsectionIds,
  seriesId,
  seriesLabel,
  totalSelectedStat,
  serieModelIds,
  mini,
}) => {
  return (
    <div className={styles.seriesPanel}>
      <span className={styles.seriesHeader}>
        <span className={styles.seriesLabel}>{seriesLabel}</span>
        <span className={styles.selectedStat}>{totalSelectedStat}</span>
      </span>
      <span className={styles.templatesContainer}>
        {subsectionIds.map(subsectionId => (
          <Subsection
            key={`${seriesId}-${subsectionId}`}
            subsectionId={subsectionId}
            seriesId={seriesId}
          />
        ))}
      </span>
    </div>
  );
};

SeriesPanel.propTypes = {
  subsectionIds: PropTypes.array.isRequired,
  seriesId: PropTypes.string.isRequired,
  seriesLabel: PropTypes.string.isRequired,
  totalSelectedStat: PropTypes.string.isRequired,
};

export default enhance(SeriesPanel);
